import React, { Component } from "react";
import Dropzone from "react-dropzone";
import {
  Paper,
  Drawer,
  Divider,
  RaisedButton,
  TextField,
  SelectField,
  AutoComplete,
  MenuItem,
  FlatButton,
  Dialog,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableRowColumn,
} from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class DocumentIndex extends Component {
  componentDidMount() {
    this.props.authFetchWorkorders("documents", this.props.token.jwt);
  }

  state = {
    open: false,
    drawerOpen: false,
    dataSource: [],
    client: {},
    year: "",
    docType: "",
    file: "",
    url: "",
    signedRequest: "",
    selectedItem: "",
    pdfUrl: "",
    fileKey: "",
  };

  getStyles() {
    return {
      center: {
        textAlign: "center",
      },
      zone: {
        width: "100%",
        height: "150px",
        border: "3px dashed red",
      },
      activeZone: {
        width: "100%",
        height: "150px",
        border: "3px dashed green",
        backgroundColor: "Aquamarine",
      },
      drawer: {
        height: "100%",
        width: "100%",
        textAlign: "center",
        display: "inline-block",
      },
    };
  }

  linkFormatter(cell, row) {
    return <a href={`/clients/${row.id}`}>{row.name}</a>;
  }

  render() {
    let { center, zone, activeZone, drawer } = this.getStyles();
    let { open, drawerOpen, pdfUrl, dataSource, year, docType } = this.state;
    let filter = { type: "TextFilter", delay: 500 };

    const dataSourceConfig = {
      text: "name",
      value: "id",
    };

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.handleUpload}
      />,
    ];

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h3>
              Temporary Documents Pending Upload to Permanent Storage
              <br />
              <Divider />
            </h3>
            <RaisedButton
              style={{ color: "#424242" }}
              label="New Upload"
              fullWidth={true}
              onTouchTap={this.handleOpen}
            />
          </center>
          <Drawer
            open={drawerOpen}
            width={500}
            docked={true}
            openSecondary={true}
          >
            <RaisedButton
              label="Close Viewer"
              fullWidth={true}
              onTouchTap={this.closeViewer}
              secondary={true}
            />
            <iframe id="myIframe" src={pdfUrl} height="1000" width="500" />
          </Drawer>
          <Dialog
            title="New Document Upload"
            actions={actions}
            modal={false}
            open={open}
            onRequestClose={this.handleClose}
          >
            <AutoComplete
              onUpdateInput={this.handleSearch}
              floatingLabelText="Client"
              fullWidth={true}
              dataSource={dataSource}
              dataSourceConfig={dataSourceConfig}
              onNewRequest={this.handleClient}
            />
            <SelectField
              floatingLabelText="Year"
              fullWidth={true}
              onChange={this.handleYearChange}
              value={year}
            >
              <MenuItem value="2015" primaryText="2015" />
              <MenuItem value="2016" primaryText="2016" />
              <MenuItem value="2017" primaryText="2017" />
            </SelectField>
            <SelectField
              floatingLabelText="Document Type"
              fullWidth={true}
              onChange={this.handleDocType}
              value={docType}
            >
              <MenuItem value="Un-signed 8879" primaryText="Un-signed 8879" />
              <MenuItem
                value="Un-signed Engagement Letter"
                primaryText="Un-signed Engagement Letter"
              />
            </SelectField>
            <Dropzone
              ref="files"
              onDrop={this.onDropFile}
              disablePreview={true}
              style={zone}
              activeStyle={activeZone}
            />
          </Dialog>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn dataField="id" filter={filter} isKey>
              ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="client" filter={filter}>
              Client
            </TableHeaderColumn>
            <TableHeaderColumn dataField="document_type" filter={filter}>
              Document Type
            </TableHeaderColumn>
            <TableHeaderColumn dataField="year" filter={filter}>
              Year
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }

  closeViewer = () => {
    this.setState({ drawerOpen: false });
  };

  handleSelection = (rows) => {
    if (rows.length > 0) {
      let selected = this.props.documents[rows[0]];
      this.setState({
        selectedItem: selected,
        pdfUrl: selected.url,
        fileKey: selected.key,
        drawerOpen: true,
      });
    }
  };

  handleYearChange = (e, i, val) => {
    this.setState({ year: val });
  };

  handleDocType = (e, i, val) => {
    this.setState({ docType: val });
  };

  documentRow = (document) => {
    let { id, document_type, year, file_type, client } = document;
    let clientLink = <a href={`/clients/${client.id}`}>{client.name}</a>;

    return (
      <TableRow key={id}>
        <TableRowColumn>{id}</TableRowColumn>
        <TableRowColumn>{clientLink}</TableRowColumn>
        <TableRowColumn>{document_type}</TableRowColumn>
        <TableRowColumn>{year}</TableRowColumn>
      </TableRow>
    );
  };

  handleSearch = (searchTerm) => {
    let url = "/accounts/search";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ searchTerm }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        let result = json[0];

        if (result !== undefined) {
          this.setState({ dataSource: [result] });
        }
      });
  };

  handleClient = (chosen) => {
    this.setState({ client: chosen });
  };

  onDropFile = (files) => {
    let fileCount = files.length;
    files.forEach((file) => {
      this.getSignedRequest(file);
    });
  };

  handleUpload = () => {
    let { file, signedRequest, url } = this.state;

    this.uploadFile(file, signedRequest, url).then(() => {
      this.createDocumentItem(file.name, url, file.type).then((res) => {
        this.handleClose();
      });
    });
  };

  createDocumentItem = (key, url, fileType) => {
    let { year, docType, client } = this.state;

    return new Promise((resolve, reject) => {
      let url = "/document/new";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          url: url,
          key: key,
          year: year,
          document_type: docType,
          file_type: fileType,
          client_id: client.id,
        }),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          resolve(json);
        });
    });
  };

  getSignedRequest = (file) => {
    let url = `/sign_s3?file_name=${file.name}&file_type=${file.type}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          file: file,
          signedRequest: json.signed_request,
          url: json.url,
          jwt: this.props.token.jwt,
        });
      });
  };

  uploadFile(file, signed_request, url) {
    return new Promise((resolve, reject) => {
      fetch(signed_request, {
        method: "PUT",
        headers: {
          "x-amz-acl": "public-read",
        },
        body: file,
      }).then((res) => {
        if (res.status >= 200 && res.status < 300) {
          resolve("url");
        } else {
          reject("There was an upload error");
        }
      });
    });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
}



// WEBPACK FOOTER //
// ./app/components/documents/DocumentIndex.js